import { type FC, memo } from 'react';
import { type IControl, type MapInstance, useControl } from 'react-map-gl/mapbox';

interface Props {
  onFitRequest: () => void;
}

class FitToFeatureControl implements IControl {
  _map: MapInstance | undefined;
  _container: HTMLElement | null = null;
  onClick: () => void;

  constructor(onClick: () => void) {
    this.onClick = onClick;
  }

  onAdd(map: MapInstance) {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    this._container.addEventListener('contextmenu', (e) => e.preventDefault());
    this._container.addEventListener('click', () => this.onClick());

    this._container.innerHTML = `
        <button class="mapboxgl-ctrl-fit-to-viewport" type="button" aria-label="Zoom in" aria-disabled="false">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 448 512"
            style="
              height: 60%;
              color: #333333;
            "        
            >
            <!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
            <path d="M32 32C14.3 32 0 46.3 0 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM64 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H64V352zM320 32c-17.7 0-32 14.3-32 32s14.3 32 32 32h64v64c0 17.7 14.3 32 32 32s32-14.3 32-32V64c0-17.7-14.3-32-32-32H320zM448 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32V352z"/>
          </svg>
        </button>
    `;

    return this._container;
  }

  onRemove() {
    this._container?.parentNode?.removeChild(this._container);
    this._map = undefined;
  }
}

export const FitToViewportControl: FC<Props> = memo(function FitToViewportControl({
  onFitRequest,
}: Props) {
  const ctrl = useControl<FitToFeatureControl>(() => new FitToFeatureControl(onFitRequest), {
    position: 'top-right',
  });
  ctrl.onClick = onFitRequest;

  return null;
});
